var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images.length > 0)?_c('div',{staticClass:"pq-image"},_vm._l((_vm.images),function(image){return _c('div',{key:image.src},[_c('img',{staticStyle:{"max-width":"400px","margin":"10px"},attrs:{"src":image.src}})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }